import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { HPIComponentType, MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
import instance from "@services/services";
const  { clinicId } = getConstants()
const {MastersApi} = api
export const getMastersTableData = async (params:SearchParamsType):Promise<ResponseType<{list:MasterTableDataType[],totalCount:number}>>=>{
    const result = await instance.post(`${MastersApi.getAllHpiMasters}`,{...params,clinicId});
    return result.data;
}

export const getAllHPIComponents = async ():Promise<ResponseType<HPIComponentType[]>>=>{
    const result = await instance.get(`${MastersApi.getHpiComponents}?clinicId=${clinicId}`);
    return result.data;
}


export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.hpiSave}`,params);
    return result.data;
}

